export const GIFT_NOT_FOUND_ERROR = '該当するギフトコードがありません。';

export const GIFT_EXPIRED_ERROR =
  'ギフトコードの有効期限が切れています。新しいギフトコードを発行しますので、お問い合わせください。';

export const GIFT_USED_ERROR = 'ご入力されたギフトコードは既に使用済みです。';
